import { chakra } from '@chakra-ui/react'
import { ProductLogo } from './ProductLogo'

type Props = {
  width?: string
  height?: string
  id: string
}
const scale = 0.8
const transform = `scale(${scale})`

export const BasePaper: React.FC<Props> = ({ width, height, id, children }) => {
  return (
    <chakra.div
      id={id}
      width={width || '476px'}
      height={height || '673px'}
      position="relative"
      boxShadow="0px 4px 12px 0px rgba(0, 0, 0, 0.14)"
    >
      <svg
        width={width || '476'}
        height={height || '673'}
        viewBox="0 0 476 673"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <style>
          {`
  text {
    font-family: "Koruri";
  };`}
        </style>
        <rect width="476" height="673" fill="white" />
        <g transform="translate(-10, -14)">
          {children}
          <text
            fontSize={'10px'}
            fill="#6C6C6C"
            x={36 / scale}
            y={665 / scale}
            transform={transform}
          >
            ※は軽減税率対象であることを示します。
          </text>
        </g>
        <ProductLogo />
      </svg>
    </chakra.div>
  )
}
